<template>
  <div class="footer">
    <div class="container">
      <div class="footer__text">
        {{ $t("footer.tov-text") }}
      </div>
      <div class="footer__links">
        <a
          href="https://drive.google.com/file/d/1Cxvwq0APr5kCDIv5g_HtHV-n2OXz3Q5z/view?usp=sharing"
          target="_blank"
          class="footer__link"
        >
          {{ $t("footer.public-agreement") }}
        </a>
      </div>
      <div class="footer__images">
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_visa.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_mastercard.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_apple_pay.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/ic_google_pay.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/xpay.svg" />
        </div>
        <div class="footer__image">
          <img src="~@/assets/img/icons/mtb-new.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";
.footer {
  margin-top: 50px;
  padding: 15px;

  .container {
    display: flex;
    align-items: center;
  }

  &__text {
    color: $black;
    font-weight: 700;
    margin-right: 20px;
  }

  &__links {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }

  &__link {
    color: $action;

    &:hover {
      text-decoration: none;
    }
  }

  &__images {
    display: flex;
    align-items: center;
  }

  &__image {
    margin-right: 15px;
    height: 20px;

    &:last-child {
      margin-right: 0;
    }

    img {
      height: 100%;
    }
  }
}
</style>
